import { ApiError, isProblem } from "./problem";

/**
 * Mutator for the orval-generated client: same-origin fetch with the session
 * cookie, JSON in and out. RFC 9457 problems become ApiError; other non-2xx
 * bodies that the spec documents (e.g. /readyz 503) are returned like
 * successes, typed by orval's status union.
 */
export async function apiFetch<T>(
  url: string,
  init: RequestInit = {}
): Promise<T> {
  const response = await fetch(url, {
    ...init,
    credentials: "same-origin",
    headers: {
      Accept: "application/json, application/problem+json",
      ...init.headers,
    },
  });
  const text = await response.text();
  const body: unknown = text ? JSON.parse(text) : undefined;

  if (!response.ok && (isProblem(body) || body === undefined)) {
    throw new ApiError(
      isProblem(body)
        ? body
        : {
            status: response.status,
            title: response.statusText,
            type: "about:blank",
          }
    );
  }
  // orval's fetch client expects { data, status, headers }.
  return {
    data: body,
    headers: response.headers,
    status: response.status,
  } as T;
}
